import React from 'react';

export const BtnChiTietKhachHang = ({ item, onOpenModalKhachHang }) => {
    return (
        <a href="#!" onClick={() => onOpenModalKhachHang(item)} className="blue btn-link">{item.TenKhachHang}</a>
    );
};